function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null,
/*#__PURE__*/
React.createElement("style", null, ".a{fill:none;}"));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(-589.5 -136.5)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(589.5 137.5)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M608.352,151.6H597.2a.492.492,0,1,1,0-.984h11.148a.166.166,0,0,0,.164-.164v-11.8a.166.166,0,0,0-.164-.164h-17.7a.166.166,0,0,0-.164.164v11.8a.166.166,0,0,0,.164.164h3.279a.492.492,0,1,1,0,.984h-3.279a1.149,1.149,0,0,1-1.148-1.148v-11.8a1.149,1.149,0,0,1,1.148-1.148h17.7a1.149,1.149,0,0,1,1.148,1.148v11.8A1.149,1.149,0,0,1,608.352,151.6Z",
  transform: "translate(-589.5 -137.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(593.107 141.434)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M612.8,150.484h-11.8a.492.492,0,1,1,0-.984h11.8a.492.492,0,1,1,0,.984Z",
  transform: "translate(-600.5 -149.5)"
}))),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(593.107 144.057)"
},
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(0 0)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M612.8,158.484h-11.8a.492.492,0,1,1,0-.984h11.8a.492.492,0,1,1,0,.984Z",
  transform: "translate(-600.5 -157.5)"
}))),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(593.107 146.68)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M608.861,166.484h-7.869a.492.492,0,1,1,0-.984h7.869a.492.492,0,0,1,0,.984Z",
  transform: "translate(-600.5 -165.5)"
})),
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(593.434 150.615)"
},
/*#__PURE__*/
React.createElement("path", {
  d: "M601.992,182.418a.491.491,0,0,1-.492-.492v-3.934a.492.492,0,0,1,.984,0v2.576l2.409-2.891a.492.492,0,1,1,.755.63l-3.279,3.934A.491.491,0,0,1,601.992,182.418Z",
  transform: "translate(-601.5 -177.5)"
})));

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  className: "a",
  width: 20,
  height: 20
});

var SvgSms = function SvgSms(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      viewBox: "0 0 20 20",
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2, _ref3, _ref4)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgSms, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/SMS.1c6d7b55.svg";
export { ForwardRef as ReactComponent };